
export interface INavigationState {
    isMinimized: boolean

}
export const initialNavigationState: INavigationState = {
    isMinimized: true
}

